import { render, staticRenderFns } from "./learning-map-content.vue?vue&type=template&id=20afaffe&scoped=true&"
import script from "./learning-map-content.ts?vue&type=script&lang=ts&"
export * from "./learning-map-content.ts?vue&type=script&lang=ts&"
import style0 from "./learning-map-content.scss?vue&type=style&index=0&id=20afaffe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20afaffe",
  null
  
)

export default component.exports